import React, { useState, useEffect } from 'react'
import { useOrderStore } from 'src/hooks/order';
import AuthConfig from "@system/config/auth";
import System from 'src/helper/system';
import { Tooltip } from 'src/component/Tooltip';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AuthRepository from 'src/repository/AuthRepository';

const OrderDetailEmailSalesPopup = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const { SetStatus } = props;
  const [CC, setCC] = useState('')
  const [CCError, setCCError] = useState('')
  const [subject, setSubject] = useState('')
  const [subjectError, setSubjectError] = useState('')
  const [message, setMessage] = useState('')
  const [messageError, setMessageError] = useState('')
  const [toEmail, setToEmail] = useState('')

  const [{ }, { send_email_order }, { }] = useOrderStore();

  const fromEmail = AuthConfig.getEmail()
  const emailRegex = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/

  useEffect(() => {
    async function fetchHere() {
      const email = await new AuthRepository().getCustomerRepresentativeEmailIdList();
      setToEmail(email)
    }
    fetchHere();
  }, []);

  const OnSend = async () => {
    let error = false
    if (CC.trim() !== '' && !CC.match(emailRegex)) {
      setCCError("Please enter a valid Email address.");
      error = true
    }
    if (subject.trim().length > 99) {
      setSubjectError('Maximum 99 characters allowed')
      error = true
    }
    if (message.trim().length > 999) {
      setMessageError('Maximum 999 characters allowed')
      error = true
    }

    if (!error) {
      let res = await send_email_order({
        "from": fromEmail,
        "to": toEmail,
        "cc": CC,
        "subject": subject,
        "emailBody": message
      })

      if (res) {
        System.alert('Your Email has been sent')
      }

      SetStatus(false)
    }
  }

  const onCCChange = (value) => {
    if (CC.trim() !== '' && !value.match(emailRegex)) {
      setCCError("Please enter a valid Email address.");
    } else {
      setCCError('')
    }
    setCC(value)
  }

  const onSubjectChange = (value) => {
    if (value.trim().length > 99) {
      setSubjectError('Maximum 99 characters allowed')
    } else {
      setSubjectError('')
    }
    setSubject(value)
  }

  const onMessageChange = (value) => {
    if (value.trim().length > 999) {
      setMessageError('Maximum 999 characters allowed')
    } else {
      setMessageError('')
    }
    setMessage(value)
  }
  return (
    <>
      <div className="avnet-modal modal-700">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">Email Sales</h3>
          </div>
          {/* Modal body */}
          <div className="modal-body pt-0">
            <div className="clearfix" />

            <div className='mb-3'>
              <div><b>From: </b> {fromEmail}</div>
              <div><b>To: </b> {toEmail}</div>
            </div>

            <div>
              <div className="form-group">
                <label htmlFor='CC'>CC</label>
                <Tooltip
                  position={'right center'}
                  opener={() => (
                    <input type="text" name="CC"
                      className="avnet-textBox form-control form-control-sm" placeholder=""
                      onChange={(e) => onCCChange(e.target.value)} value={CC} />
                  )}
                  content={() => (
                    <>
                      Add multiple Email using "," comma separator.
                    </>
                  )}
                />
                <p className="error">{CCError.trim().length > 0 && CCError}</p>
              </div>
              <div className="form-group">
                <label htmlFor="Subject">Subject</label>
                <input type="text" name="Subject"
                  className="avnet-textBox form-control form-control-sm" placeholder=""
                  onChange={(e) => onSubjectChange(e.target.value)} value={subject} />
                <p className="error">{subjectError.trim().length > 0 && subjectError}</p>
              </div>
              <div className="form-group">
                <label htmlFor="Message">Message</label>
                <textarea name="name" rows="8" cols="60" className="avnet-textBox form-control form-control-sm"
                  placeholder="Type your message.."
                  onChange={(e) => onMessageChange(e.target.value)} value={message}></textarea>
                <p className="error">{messageError.trim().length > 0 && messageError} </p>
              </div>
            </div>
          </div>
          {/* Modal footer */}
          <div className="modal-footer justify-content-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                CANCEL
              </button>
              {__check(['ORDER_EMAIL_API_CALL']).status &&

                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                  disabled={true}
                  onClick={(() => OnSend())}>
                  <i className="fa fa-spinner fa-spin" />
                </button>
              }

              {!__check(['ORDER_EMAIL_API_CALL']).status &&

                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                  onClick={(() => OnSend())}>
                  SEND
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderDetailEmailSalesPopup